<!--user-detail.vue-->
<template>
    <!--基础信息-->
    <div class="temp-part">
        <div class="temp-part-title">
            基础信息
        </div>

        <div class="item-wrap">
            <div class="detail-item">
                <div class="item-name">用户ID</div>
                <div class="item-content">
                    {{ userData.userId || '--' }}
                </div>
            </div>

            <div class="detail-item">
                <div class="item-name">用户名</div>
                <div class="item-content">
                    {{ userData.userName || '--' }}
                </div>
            </div>

            <div class="detail-item">
                <div class="item-name">手机号</div>
                <div class="item-content">
                    {{ userData.phone || '--' }}
                </div>
            </div>
        </div>

        <div class="item-wrap">
            <div class="detail-item">
                <div class="item-name">注册时间</div>
                <div class="item-content">
                    {{ userData.registerTime || '--' }}
                </div>
            </div>

            <div class="detail-item">
                <div class="item-name">最后登录时间</div>
                <div class="item-content">
                    {{ userData.lastLoginTime || '--' }}
                </div>
            </div>

            <div class="detail-item">
                <div class="item-name">openID</div>
                <div class="item-content">
                    {{ userData.openId || '--' }}
                </div>
            </div>
        </div>

        <div class="item-wrap">
            <div class="item-name">头像</div>
            <div class="avatar-wrap">
                <t-image
                    class="avatar"
                    :src="userData.avatar"
                    @click="previewAvatar"
                />
            </div>
        </div>

    </div>

    <!--评分记录-->
    <div class="temp-part">
        <div class="temp-part-title">评价记录</div>

        <!--评价列表-->
        <t-table
            :data="rateData" 
            :columns="rateColumn"
            tableLayout="auto"
            show-header="true"
            cell-empty-content="--"
            row-key="index"
            :pagination="pagination"
            resizable
            lazy-load
            size="large"
            @row-click="handleRowClick"
            bordered
            hover
        >
            
            <!--评价内容-->
            <template #rateContent="{ row }">
                <div class="rate-content-wrap">
                    <div class="rate-content-text">{{ row.rateContentText }}</div>
                    <div class="rate-image-wrap">
                        <t-image
                            v-for="(image, index) in row.rateImage"
                            class="rate-image"
                            :key="index"
                            :src="image"
                            @click="openImageViewer(row, index)"
                        />
                    </div>
                </div>
            </template>

            <!--评价营地-->
            <template #rateCamp="{ row }">
                <div class="rate-camp-wrap"> 
                    <img class="rate-camp-image" :src="row.rateCampImage" alt=""  />
                    <div rateCampInfo>
                            <div class="rate-camp-name">{{ row.rateCampName }}</div>
                            <div class="rate-camp-id">ID:{{ row.rateCampId }}</div>
                    </div>
                </div>
            </template>

            <template #action="{ row }">
                <div class="table-action">
                    <t-link
                        class="status-action"
                        theme='primary'
                        hover="color"
                        @click="switchStatus(row)"
                    >
                        {{ row.status === '正常' ? '隐藏' : '取消隐藏' }}
                    </t-link>

                    <t-link
                        class="delete-action"
                        v-if="row.status === '已隐藏'"
                        theme="danger"
                        hover="color"
                        @click="deleteItem(row)"
                    >
                        删除
                    </t-link>
                </div>
            </template>
        </t-table>
    </div>

    <t-image-viewer
        v-if="showImageViewer"
        v-model:visible="showImageViewer"
        :images="currentRowImage"
        :defaultIndex="currentImageIndex"
        :show-indicators="true"
    /> 
</template>


<script setup lang="jsx">
    import { ref, reactive,onMounted } from 'vue';
    import { useRoute } from 'vue-router';
    import { formatTime } from '../../../utils/datetime';
    import { MessagePlugin} from 'tdesign-vue-next';
    import userAPI from '../../../api/user-api';

    const route = useRoute();

    const userData = reactive({
    userId: '',
        userName: '',
        phone: '',
        registerTime: '',
        lastLoginTime: '',
        openId: '',
        avatar: ''
    });

    const getUserDetail = async () => {
        try {
            const response = await userAPI.getUserDetail(userData.userId);
            if (response.success) {
                const data = response.data;
                userData.userId = data.user_id;
                userData.userName = data.username;
                userData.phone = data.phone;
                userData.registerTime = formatTime(data.register_time);
                userData.lastLoginTime = data.last_login_time ? formatTime(data.last_login_time) : '--';
                userData.openId = data.openid || '--';
                userData.avatar = data.avatar || '';
            }
        } catch (error) {
            console.error('获取用户详情失败:', error);
            MessagePlugin.error('获取用户详情失败：' + (error.message));
        }
        };

    onMounted(() => {
        const userIdFromRoute = route.params.id;
            if (userIdFromRoute) {
                userData.userId = userIdFromRoute;
                getUserDetail();
            } else {
                MessagePlugin.error('未找到用户ID');
            }
    });

    const renderMask = () => (
        <div
            style={{
                background: 'rgba(0,0,0,.6)',
                color: '#fff',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            预览
        </div>
    );
        
    const switchStatus=(row)=>{
        row.status=row.status==='正常'?'已隐藏' : '正常';
    }

    /**表格字段-评价记录*/
    const rateColumn=ref([
        { colKey: 'rateTime', title: '评价时间',width: 200},
        { colKey: 'rate', title: '评分'},
        { colKey: 'rateContent', title: '评价内容' },
        { colKey: 'rateCamp', title: '评价营地'},
        { colKey: 'status', title: '状态'},
        { colKey: 'action', title: '操作', width: 200},
    ]);

    //表格数据-评价记录
    const rateData=ref([
        { 
        rateUserName:'张万里',
        rateUserId:'00000001',
        rateTime:'2024-12-09 08:32:48',
        rateContentText:'Glamping才是春日出游的最佳选择！既野性又奢华，简直让人欲罢不能！',
        rateImage:[
            'https://yequ-1331262631.cos.ap-nanjing.myqcloud.com/00000001/00000001.png',
            'https://yequ-1331262631.cos.ap-nanjing.myqcloud.com/00000001/00000002.png',
            'https://yequ-1331262631.cos.ap-nanjing.myqcloud.com/00000001/00000002.png',
        ],
        rateContent:'游牧生态村草原营地',
        rateCampImage:'https://yequ-1331262631.cos.ap-nanjing.myqcloud.com/00000001/00000001.png',
        rateCampName:'大滩梨花梯田',
        rateCampId:'00000001',
        rate:'4.8',
        status:'已启用',
        
        updateBy:'admin',
        },
    ]);
    

    /**图片预览*/
    const showImageViewer = ref(false); //图片预览默认隐藏
    const currentImageIndex = ref(0); //图片在图片数组索引
    const currentRowImage = ref([]) //存储当前行所有图片，初始为空

    //头像图片预览
    const previewAvatar = () => {
        currentRowImage.value = [avatar.value];
        currentImageIndex.value = 0;
        showImageViewer.value = true;
    };

    //评价图片预览
    const openImageViewer = (row, index) => {
        currentRowImage.value = row.rateImage || [];
        currentImageIndex.value = index;
        showImageViewer.value = true; 
    }; 

    const handleRowClick = (row) => {
      // 处理行点击事件
      console.log('Clicked row:', row);
    };



</script>

<style scoped>
  @import "./user-detail.css";
  @import "../../../components/style/style-table.css";
  @import "../../../components/style/style-detail.css";
</style>
